import { render, staticRenderFns } from "./PowerballFolders.vue?vue&type=template&id=fc124462&scoped=true"
import script from "./PowerballFolders.vue?vue&type=script&lang=js"
export * from "./PowerballFolders.vue?vue&type=script&lang=js"
import style0 from "./PowerballFolders.vue?vue&type=style&index=0&id=fc124462&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc124462",
  null
  
)

export default component.exports